import { AdminProfile } from "@/types";

export enum ActionTypes {
	LOGOUT = "LOGOUT",
	LOGIN = "LOGIN",
	SET_USER = "SET_USER",
}

export type Action =
	| {
			type: ActionTypes.LOGOUT;
	  }
	| {
			type: ActionTypes.LOGIN;
			payload: { token: string };
	  }
	| {
			type: ActionTypes.SET_USER;
			payload: AdminProfile;
	  };

export type State = {
	token: string;
	user: AdminProfile | null;
};

export type Dispatch = (action: Action) => void;

export type AuthProviderProps = { children: React.ReactNode };
